export const SUPPORT_PHONE_NUMBER = '(844) 913-1386';
